import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { QrObrasService } from '../services/qr-obra-service';


@Injectable({
  providedIn: 'root'
})
export class QrObraFiltersResolver implements Resolve<boolean> {

  constructor(private service: QrObrasService) { }

  resolve(): Observable<any> {
    return this.service.getListFilters();
  }
}

@Injectable({
  providedIn: 'root'
})
export class QrObraCombosResolver implements Resolve<boolean> {

  constructor(private service: QrObrasService) { }

  resolve(): Observable<any> {
    return this.service.getListCombos();
  }
}